var customerId = $('.ga_customerId').val();


// removeWishlistProduct is used to remove wishlist items from the wishlist page
// removeWishlistProduct is using v2 version
// this method not in use
function removeWishlistProduct(productObj){
  var removeFromWishlistUrl = cartBaseUrl+removeFromWishlistEndPoint;
  var responseStatus = 200;
  $.blockUI({ message: '<img src="https://cdn.shopify.com/s/files/1/0820/8999/files/new-butterfly_1.gif?15302941410807159202" style="width:160px;height:auto;"><p>Please wait</p>',
                   css:{
                     'padding-bottom':'20px',
                      background: 'rgba(0, 0, 0, 0.4)',
                      border:'#4c4c4c',
                      color:'#fff',
                     'border-radius':'6px'
                   }
                   });
  var wishlistId = (productObj.wishlistId);
  var removeWishListObj = {};
  removeWishListObj["wishlist_id"] = wishlistId;
  removeWishListObj["is_liked"] = false;
  var jsonString = JSON.stringify(removeWishListObj);
  
  $.ajax({
          async:false,
          type: 'PUT',
          timeout: ajaxCallTimeout,
          dataType: 'json',
          contentType: 'application/json',
          headers: v2Header,
          error: function (data) {
            responseStatus = data.status;
            var responseErrorObj = JSON.parse(data.responseText);
            var errorObj = responseErrorObj.error;
            var errorMessage = errorObj.message;
            Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
            Sentry.captureException(data);
            swal({
              title: 'Sorry',
              text: errorMessage,
              type: 'error',
              confirmButtonText: 'OK',
              closeOnCancel: false,
              allowOutsideClick: false
            });
          },
          data:jsonString,
          url: removeFromWishlistUrl,
          statusCode: {
            200: function (data) {
              responseStatus = 200;
            },
            302: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
              Sentry.captureException(data);
              swal({
                title: '',
                text: errorMessage,
                type: 'error',
                confirmButtonText: 'OK',
                closeOnCancel: false,
                allowOutsideClick: false
              });
              $('.swal2-confirm').click(function () {
                location.reload(true);
              });
            },
            401:function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
              Sentry.captureException(data);
            },
            403: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
              Sentry.captureException(data);
              swal({
                title: '',
                text: errorMessage,
                type: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
            },
            400: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
              Sentry.captureException(data);
              $.unblockUI();
              swal({
                title: '',
                text: errorMessage,
                type: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
            },
            500: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
              Sentry.captureException(data);
              swal({
                title: '',
                text: errorMessage,
                type: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
            }
          }
        }).fail(function(data, textStatus, xhr){
          console.log(data.getResponseHeader('x-request-id'));
        });
  return responseStatus;
}

// v3RemoveFromWishlistPage function is used in the wishlist page 
function v3RemoveFromWishlistPage(productObj){
  var removeFromWishlistUrl = cartBaseUrl+v3RemoveFromWishlistEndPoint+customerId;
  var responseStatus = 200;
  $.blockUI({ message: '<img src="https://cdn.shopify.com/s/files/1/0820/8999/files/new-butterfly_1.gif?15302941410807159202" style="width:160px;height:auto;"><p>Please wait</p>',
                   css:{
                     'padding-bottom':'20px',
                      background: 'rgba(0, 0, 0, 0.4)',
                      border:'#4c4c4c',
                      color:'#fff',
                     'border-radius':'6px'
                   }
                   });
  var variantId = productObj.variantId;
  var productId = productObj.productId;
  var removeWishListObj = {};
  removeWishListObj["variant_id"] = variantId;
  removeWishListObj["product_id"] = productId;
  var jsonString = JSON.stringify(removeWishListObj);
  
  $.ajax({
          async:false,
          type: 'DELETE',
          timeout: ajaxCallTimeout,
          dataType: 'json',
          contentType: 'application/json',
          headers: getV3Header(customerId),
          error: function (data) {
            responseStatus = data.status;
            var responseErrorObj = JSON.parse(data.responseText);
            var errorObj = responseErrorObj.error;
            var errorMessage = errorObj.message;
            Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
            Sentry.captureException(data);
            swal({
              title: 'Sorry',
              text: errorMessage,
              type: 'error',
              confirmButtonText: 'OK',
              closeOnCancel: false,
              allowOutsideClick: false
            });
          },
          data:jsonString,
          url: removeFromWishlistUrl,
          statusCode: {
            200: function (data) {
              responseStatus = 200;
            },
            302: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
              Sentry.captureException(data);
              swal({
                title: '',
                text: errorMessage,
                type: 'error',
                confirmButtonText: 'OK',
                closeOnCancel: false,
                allowOutsideClick: false
              });
              $('.swal2-confirm').click(function () {
                location.reload(true);
              });
            },
            401:function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
              Sentry.captureException(data);
            },
            403: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
              Sentry.captureException(data);
              swal({
                title: '',
                text: errorMessage,
                type: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
            },
            400: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
              Sentry.captureException(data);
              $.unblockUI();
              swal({
                title: '',
                text: errorMessage,
                type: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
            },
            500: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
              Sentry.captureException(data);
              swal({
                title: '',
                text: errorMessage,
                type: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
            }
          }
        }).fail(function(data, textStatus, xhr){
          console.log(data.getResponseHeader('x-request-id'));
        });
 return responseStatus
}

// collection or product page add to wishlist function 
function addToWishlist(productObj,pageName){
  $.blockUI({ message: '<img src="https://cdn.shopify.com/s/files/1/0820/8999/files/new-butterfly_1.gif?15302941410807159202" style="width:160px;height:auto;"><p>Please wait</p>',
                   css:{
                     'padding-bottom':'20px',
                      background: 'rgba(0, 0, 0, 0.4)',
                      border:'#4c4c4c',
                      color:'#fff',
                     'border-radius':'6px'
                   }
                   });
  var responseStatus = 200;
  var moveToWishListUrl = cartBaseUrl+collectionAndProductPageMoveToWishlistEndPoint;
  if(!($.isEmptyObject(productObj))){
    var productId = "";
    var varinatId = "";
    var imageUrl = "";
    var productSku = "";
    if(productObj.productId !== null){
        productId = (productObj.productId).toString();
    }
    if(productObj.variantId !== null){
      varinatId = (productObj.variantId).toString();
    }
    if((productObj.imagesArray).length>0){
      imageUrl = (productObj.imagesArray)[0];
    }
    if(productObj.productSku !== null){
      productSku = productObj.productSku;
    }
    var moveToWishlistObj = {};
    moveToWishlistObj["product_id"] = (productId).toString();
    moveToWishlistObj["variant_id"] = (varinatId).toString();
    moveToWishlistObj["img_url"] = (imageUrl).toString();
    moveToWishlistObj["sku"] = (productSku).toString();
    moveToWishlistObj["customer_id"] = (customerId).toString();
    var jsonString = JSON.stringify(moveToWishlistObj);
     $.ajax({
        type: 'POST',
        async:false,
        timeout: ajaxCallTimeout,
        dataType: 'json',
        contentType: 'application/json',
        headers: v2Header,
        error: function (data) {
            $.unblockUI();
            responseStatus = data.status;
        },
        url: moveToWishListUrl,
        data:jsonString,
        statusCode: {
            200: function (data) {
              
              var newWishlistedLieItemObj = {};
              if(!($.isEmptyObject(data))){
                var isWishlistObjExists = data.hasOwnProperty("wishlist");
                if(isWishlistObjExists === true){
                  var responseWishlistObj = data.wishlist;
                  if(!($.isEmptyObject(responseWishlistObj))){
                    var prodictId = responseWishlistObj.product_id;
                    var variantId = responseWishlistObj.variant_id;
                    var wishlistId = responseWishlistObj.wishlist_id;
                    newWishlistedLieItemObj["productId"] = prodictId;
                    newWishlistedLieItemObj["variantId"] = variantId;
                    newWishlistedLieItemObj["wishlistId"] = wishlistId;
                    
                  }
                }
              }
              
//               localstorage method
              if(typeof('Storage') !== undefined){
                var localStorageWishlistLineItemsAray = [];
                var localStorageCartLineItemsArray = [];
                
                var cartWishlistArray = [];
                
                var isProductDetailObjExists = localStorage.hasOwnProperty("productDetail");
                if(isProductDetailObjExists === true){
                  var localStorageCartDetailObj = JSON.parse(localStorage.getItem("productDetail"));
                  if(!($.isEmptyObject(localStorageCartDetailObj))){
                    var iswishlistLineItemsArrayExists = localStorageCartDetailObj.hasOwnProperty("wishlistLineItemsArray");
                    if(iswishlistLineItemsArrayExists === true){
                      localStorageWishlistLineItemsAray = localStorageCartDetailObj.wishlistLineItemsArray;
                      if(localStorageWishlistLineItemsAray.length>0){
                        localStorageWishlistLineItemsAray.push(newWishlistedLieItemObj);
                      }
                      else{
                        cartWishlistArray.push(newWishlistedLieItemObj);
                      }
                    }
                    var isCartLineItemArrayExists = localStorageCartDetailObj.hasOwnProperty("cartLinrItemsArray");
                    if(isCartLineItemArrayExists === true){
                      localStorageCartLineItemsArray = localStorageCartDetailObj.cartLinrItemsArray;
                    }
                  }
                }
                var localStorageCartObj = {};
                localStorageCartObj["cartLinrItemsArray"] = localStorageCartLineItemsArray;
                if(localStorageWishlistLineItemsAray.length>0){
                  localStorageCartObj["wishlistLineItemsArray"] = localStorageWishlistLineItemsAray;
                }
                else{
                  localStorageCartObj["wishlistLineItemsArray"] = cartWishlistArray;
                }
                var localStorageJsonString = JSON.stringify(localStorageCartObj);
                localStorage.setItem("productDetail",localStorageJsonString);
              }
              fb_moveToWishList(productObj);
              responseStatus = 200;
            },
            302: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in moveToWishList function'+errorMessage);
              Sentry.captureException(data);
              
              $.unblockUI();
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    closeOnCancel: false,
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            401:function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in moveToWishList function'+errorMessage);
              Sentry.captureException(data);
              $.unblockUI();
            },
            403: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in moveToWishList function'+errorMessage);
              Sentry.captureException(data);
              $.unblockUI();
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            400: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in moveToWishList function'+errorMessage);
              Sentry.captureException(data);
              
              $.unblockUI();
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            500: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in moveToWishList function'+errorMessage);
              Sentry.captureException(data);
              
              $.unblockUI();
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            }
        }
    }).fail(function(data, textStatus, xhr){
        console.log(data.getResponseHeader('x-request-id'));
        });
    return responseStatus;
  }
}

// removeFromWishlist is used in the remove 
// from the wishlist in the prodcut and collection page
function removeFromWishlist(productObj){
  if(productObj !== undefined){
    if(!($.isEmptyObject(productObj))){
      var removeFronWishlistUrl = cartBaseUrl+collectionAndProductPageMoveToWishlistEndPoint;
      var responseStatus = 200; 
      var localStorageCartLineItemsArray = [];
      var localStorageWishlistLineItemsArray = [];
      var productId = "";
      var varinatId = "";
      var imageUrl = "";
      var productSku = ""; 
      var wishlistId = "";
      var isLiked = false;
      if(productObj.productId !== null){
        productId = (productObj.productId).toString();
      }
      if(productObj.variantId !== null){
        varinatId = (productObj.variantId).toString();
      }
      if((productObj.imagesArray).length>0){
        imageUrl = ((productObj.imagesArray)[0]).toString();
      }
      if(productObj.productSku !== null){
        productSku = (productObj.productSku).toString();
      }
      
      if(typeof('Storage') !== undefined ){
        var isLocalStorageProductObjExists = localStorage.hasOwnProperty("productDetail");
        if(isLocalStorageProductObjExists === true){
          var localStorageCartDetailObj = JSON.parse(localStorage.getItem("productDetail"));
          if(!($.isEmptyObject(localStorageCartDetailObj))){
            var isWishlistLineItemArrayExists = localStorageCartDetailObj.hasOwnProperty("wishlistLineItemsArray");
            if(isWishlistLineItemArrayExists === true){
              if(localStorageCartDetailObj.wishlistLineItemsArray !== null){
                localStorageWishlistLineItemsArray = localStorageCartDetailObj.wishlistLineItemsArray;
                if(localStorageWishlistLineItemsArray.length>0){
                  var i;
                  var arrayLength = localStorageWishlistLineItemsArray.length;
                  for(i=0;i<arrayLength;i++){
                    var localStorageWishlistObj = localStorageWishlistLineItemsArray[i];
                    if(!($.isEmptyObject(localStorageWishlistObj))){
                      var localStorageWishlistProductId = (localStorageWishlistObj.productId).toString();
                      var localStorageWishlistVariantId = (localStorageWishlistObj.variantId).toString();
                      if(productId === localStorageWishlistProductId &&
                         varinatId === localStorageWishlistVariantId ){
                         wishlistId = localStorageWishlistObj.wishlistId;
                      }
                    }
                  }
                }
              }
              var isCartLineItemArrayExists = localStorageCartDetailObj.hasOwnProperty("cartLinrItemsArray");
              if(isCartLineItemArrayExists === true){
                localStorageCartLineItemsArray = localStorageCartDetailObj.cartLinrItemsArray;
              }
            }
          }
        }
      }/* local storage iteration ends here */
      var removeFromWishlistObj = {};
      removeFromWishlistObj["product_id"] = productId;
      removeFromWishlistObj["variant_id"] = varinatId;
      removeFromWishlistObj["img_url"] = imageUrl;
      removeFromWishlistObj["sku"] = productSku;
      removeFromWishlistObj["is_liked"] = isLiked;
      removeFromWishlistObj["customer_id"] = (customerId).toString();
      removeFromWishlistObj["wishlist_id"] = parseInt(wishlistId);
      
      var jsonString = JSON.stringify(removeFromWishlistObj);
      
      $.ajax({
        type: 'PUT',
        async:false,
        timeout: ajaxCallTimeout,
        dataType: 'json',
        contentType: 'application/json',
        headers: v2Header,
        error: function (data) {
            $.unblockUI();
            responseStatus = data.status;
        },
        url: removeFronWishlistUrl,
        data:jsonString,
        statusCode: {
            200: function (data) {
              if(localStorageWishlistLineItemsArray.length>0){
                var j;
                var localStorageWishlistArrayLength = localStorageWishlistLineItemsArray.length;
                for(j=0;j<localStorageWishlistArrayLength;j++){
                  var lineItemObj = localStorageWishlistLineItemsArray[j];
                  if(!($.isEmptyObject(lineItemObj))){
                    var pid = (lineItemObj.productId).toString();
                    var vid = (lineItemObj.variantId).toString();
                    if(productId === pid && varinatId === vid ){
                      localStorageWishlistLineItemsArray = jQuery.grep(localStorageWishlistLineItemsArray, function(value) {
  										return value != localStorageWishlistLineItemsArray[j];
									});
                      var updatedLocalStorageObj = {}
                      updatedLocalStorageObj["wishlistLineItemsArray"] = localStorageWishlistLineItemsArray;
                      updatedLocalStorageObj["cartLinrItemsArray"] = localStorageCartLineItemsArray;
                      var localstorageObjJsonString = JSON.stringify(updatedLocalStorageObj);
                      localStorage.setItem("productDetail",localstorageObjJsonString);
                      break;
                    }
                  }
                }
              }
              responseStatus = 200;
            },
            302: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in moveToWishList function'+errorMessage);
              Sentry.captureException(data);
              
              $.unblockUI();
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    closeOnCancel: false,
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            401:function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in moveToWishList function'+errorMessage);
              Sentry.captureException(data);
              $.unblockUI();
            },
            403: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in moveToWishList function'+errorMessage);
              Sentry.captureException(data);
              $.unblockUI();
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            400: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in moveToWishList function'+errorMessage);
              Sentry.captureException(data);
              
              $.unblockUI();
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            500: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
              Sentry.captureMessage('Error in moveToWishList function'+errorMessage);
              Sentry.captureException(data);
              
              $.unblockUI();
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            }
        }
    }).fail(function(data, textStatus, xhr){
        console.log(data.getResponseHeader('x-request-id'));
        });
      return responseStatus;
    }
  }
}
